import React, { useState, useEffect } from "react";
import {
  Header,
  Grid,
  Breadcrumb,
  Icon,
} from "semantic-ui-react";
import { Checkbox, Select } from "antd";
import Tabs from "./Tabs/Tabs";

import axios from "axios";
const { Option } = Select;
const filtrarPorArea = [
  {
    key: 1,
    value: 1,
    text: "Adquisición de equipos y herramientas tecnológicas",
  },
  {
    key: 2,
    value: 2,
    text: "Apoyo para la participación en ferias y eventos del sector",
  },
  {
    key: 3,
    value: 3,
    text: "Áreas integradas",
  },
  { key: 4, value: 4, text: "Arte" },
];
const filtrarPorEstado = [
  {
    key: 1,
    value: 1,
    text: "Aprobado",
  },
  {
    key: 2,
    value: 2,
    text: "Reprobado",
  },
  { key: 3, value: 3, text: "Sin verificar" },
];
const cantidadRegistros = [
  {
    key: 1,
    value: 10,
    text: "10",
  },
  {
    key: 2,
    value: 20,
    text: "20",
  },
  { key: 3, value: 50, text: "50" },
  { key: 4, value: 100, text: "100" },
];
const initialState = {
  datossinfiltro: [],
};

export const GestionarPostulacionesJurados = () => {
  // State filtro de Estado
  // fake state para switchear entre usuario evaluador y usuario admin
  const [userPermissions, setUserPermissions] = useState(true);
  const [jurados, setJurados] = useState([]);

  const filterByMany = async (url: string) => {
    const response = await axios.get(url);

    if (response.data.juries) {
      setJurados(response.data.juries);
    }
  };

  const selectFilterEstado = async () => {
    const token = localStorage.getItem('token');

    await axios.get(
      `${process.env.REACT_APP_SERVER_JURA2}juries/filter/status/?status=${selectFilter}`,
      {
        headers: {
          'Authorization': token
        }
      }
    );
  };

  const selectFilter = async (e: any) => {
    const token = localStorage.getItem('token');

    let response = await axios.get(
      `${process.env.REACT_APP_SERVER_JURA2}juries/filter/status/?status=${e}`, 
      {
        headers: {
          'Authorization': token
        }
      }
    );
    if (response.data.juries) {
      //
      setJurados(response.data.juries);
    }
  };

  const inputFilter = async (e: any) => {
    const token = localStorage.getItem('token');

    let response = await axios.get(
      `${process.env.REACT_APP_SERVER_JURA2}juries/filter/code-word/?code_word=${e.target.value}`,
      {
        headers: {
          'Authorization': token
        }
      }
    );
    if (response.data.juries) {
      //
      setJurados(response.data.juries);
    }

    let datos: React.SetStateAction<any[]> = [];

    setJurados(datos);
    console.log(e.target.value);
  };

  const primeroDatostabla = async () => {
    const token = localStorage.getItem('token');
    
    try {
      let response = await axios.get(
        `${process.env.REACT_APP_SERVER_JURA2}juries/`,
        {
          headers: {
            'Authorization': token
          }
        }
      );
      if (response.data.juries) {
        //
        setJurados(response.data.juries);
      }

      let datos: React.SetStateAction<any[]> = [];
      setJurados(datos);
    } catch (error) {
      return console.error(error);
    }
  };

  useEffect(() => {
    primeroDatostabla();
    selectFilterEstado();
  }, []);
  return (
    <div className="h-100">
      {/* Componente de breadcrumb */}
      <Grid className="no-margin">
        <Grid.Column
          className="background-color-101c31 no-margin no-padding-top no-padding-bottom"
          style={{ padding: "4px 0" }}
        >
          <Breadcrumb style={{ paddingLeft: "4%" }}>
            <Breadcrumb.Section>
              <Icon name="home" className="font-color-FFFFFF" size="small" />
            </Breadcrumb.Section>
            <Breadcrumb.Divider className="font-color-FFFFFF font-size-8px">
              /
            </Breadcrumb.Divider>
            <Breadcrumb.Section className="font-family-Montserrat-Regular font-color-FFFFFF font-size-8px">
              Jurados
            </Breadcrumb.Section>
            <Breadcrumb.Divider className="font-color-FFFFFF font-size-8px">
              /
            </Breadcrumb.Divider>
            <Breadcrumb.Section className="font-family-Montserrat-Regular font-color-FFFFFF font-size-8px">
              Banco de jurados
            </Breadcrumb.Section>
          </Breadcrumb>
        </Grid.Column>
      </Grid>
      {/* Header */}
      <Grid style={{ backgroundColor: "#fff" }} className="no-margin">
        <Grid.Column>
          <Header as="h3" style={{ padding: "0 10px", display: "flex" }}>
            <div style={{ width: "450px" }}>
              Gestionar postulación de jurados
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <div
                style={{
                  padding: "0 10px",
                  display: "flex",
                  justifyContent: "space-around",
                }}
              >
                <Checkbox onChange={() => setUserPermissions(!userPermissions)}>
                  {userPermissions ? (
                    <span>Administrador</span>
                  ) : (
                    <span>Evaluador</span>
                  )}
                </Checkbox>
              </div>
            </div>
            <Header></Header>
          </Header>
        </Grid.Column>
      </Grid>
      <Tabs
        Tabla={jurados}
        setJurados={setJurados}
        primeroDatostabla={primeroDatostabla}
        selectFilter={selectFilter}
        inputFilter={inputFilter}
        userPermissions={userPermissions}
        filterByMany={filterByMany}
      />
    </div>
  );
};

GestionarPostulacionesJurados.propTypes = {};
